export const governorates = [
  "دمشق",
  "ريف دمشق",
  "قلمون",
  "حلب",
  "ريف حلب",
  "حمص",
  "ريف حمص",
  "حماة",
  "ريف حماه",
  "اللاذقية",
  "ريف اللاذقية",
  "جبله" ,
  "طرطوس",
  "ريف طرطوس",
  "درعا",
  "السويداء",
  "القنيطرة",
  "دير الزور",
  "الرقة",
  "القامشلي" ,
  "البوكمال",
  "الحسكة",
  "إدلب",
  "بانياس",
];

export const governoratesWithId = [
  { "id": 2, "name": "دمشق" },
  { "id": 3, "name": "ريف دمشق" },
  { "id": 4, "name": "قلمون" },
  { "id": 5, "name": "حمص" },
  { "id": 6, "name": "ريف حمص" },
  { "id": 7, "name": "طرطوس" },
  { "id": 8, "name": "ريف طرطوس" },
  { "id": 9, "name": "حماه" },
  { "id": 10, "name": "ريف حماه" },
  { "id": 11, "name": "درعا" },
  { "id": 12, "name": "اللاذقية" },
  { "id": 13, "name": "ريف اللاذقية" },
  { "id": 14, "name": "جبله" },
  { "id": 15, "name": "حلب" },
  { "id": 16, "name": "ريف حلب" },
  { "id": 17, "name": "القامشلي" },
  { "id": 18, "name": "الرقة" },
  { "id": 19, "name": "دير الزور" },
  { "id": 20, "name": "البوكمال" },
  { "id": 21, "name": "الحسكه" },
  { "id": 22, "name": "السويداء" },
  { "id": 23, "name": "ادلب" },
  { "id": 24, "name": "القنيطرة" },
  { "id": 25, "name": "بانياس" }
];


